module.exports = __webpack_public_path__ + "static/og-image-a7b82dbf1ae323e73556a1d1eca1888b.png";